<template lang="html">
  <div>
    <v-container
      grid-list-lg
      mt-4
      pb-0
      fluid
    >
      <v-layout
        wrap
        justify-center
      >
        <v-flex v-bind="_pageLayout">
          <v-layout wrap>
            <v-flex class="display-2 font-weight-light primary--text">
              Super Info Assist
            </v-flex>
            <v-flex
              mb-3
              xs12
            >
              Have your calculation completed by one of our specialists.
            </v-flex>
            <v-flex>
              <v-stepper
                v-model="stepperStep"
                alt-labels
                class=" elevation-0 transparent mx-5"
              >
                <v-stepper-header class="elevation-0">
                  <v-stepper-step
                    step="1"
                    :complete="step > 0"
                    editable
                  >
                    <v-flex
                      pa-0
                      text-center
                    >
                      Information
                    </v-flex>
                  </v-stepper-step>
                  <v-divider />
                  <v-stepper-step
                    step="2"
                    :complete="step > 1"
                  >
                    <v-flex
                      pa-0
                      text-center
                    >
                      Payment
                    </v-flex>
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <v-flex
      xs12
      style="height:1px"
    >
      <!-- this is here to stop the window jupmping when it transitions. Because science. -->
    </v-flex>

    <v-window
      v-model="step"
      touchless
    >
      <v-window-item key="1">
        <v-container
          grid-list-md
          pt-0
          fluid
        >
          <v-layout wrap>
            <v-flex v-bind="_pageLayout">
              <v-layout wrap>
                <v-scroll-y-transition>
                  <v-flex pa-0>
                    <v-form
                      ref="form"
                      v-model="formValid"
                    >
                      <v-flex
                        mt-4
                        mb-3
                      >
                        <span class="headline font-weight-light">Calculation Details</span>
                        <v-divider />
                      </v-flex>
                      <v-flex xs12>
                        <SiInputWrapper
                          apply-layout
                          help-spacing
                        >
                          <SiInputAutocomplete
                            v-model="request.calculation"
                            label="Calculation"
                            :items="calculatorItems"
                            filled
                            required
                            :loading="_loader"
                          />
                        </SiInputWrapper>
                      </v-flex>
                      <v-scroll-y-transition>
                        <v-flex
                          v-if="addons.length > 0"
                          xs12
                        >
                          <SiInputWrapper
                            apply-layout
                            help="Additional services available with this calculation"
                          >
                            <SiInputSelect
                              v-model="request.addons"
                              multiple
                              label="Add-on services"
                              :items="addons"
                              filled
                            />
                          </SiInputWrapper>
                        </v-flex>
                      </v-scroll-y-transition>
                      <v-scroll-y-transition>
                        <v-flex
                          v-if="(request.calculation || {}).calculator && (assistanceTypes || []).length > 0"
                          xs12
                        >
                          <SiInputWrapper
                            apply-layout
                            help="Turn-around times not guaranteed. </br> Actual delivery times can be impacted by accuracy of information supplied, complexity of your situation and the need to discuss your individual circumstances. In all cases, we aim to perform your calculation within the given time frame and most of the time deliver before your due date."
                          >
                            <SiInputAutocomplete
                              v-model="request.assistanceType"
                              label="Assistance type"
                              :items="assistanceTypes"
                              filled
                              required
                              persistent-hint
                              hint="We do not guarantee turn-around times. See help form more information"
                            />
                          </SiInputWrapper>
                        </v-flex>
                      </v-scroll-y-transition>
                      

                      <v-flex
                        v-if="(calculatorVariant.assistanceFields || []).length > 0 "
                        xs12
                        mt-4
                        mb-3
                      >
                        <span class="headline font-weight-light">Additional Information</span>
                        <v-divider />
                        <v-progress-linear
                          :indeterminate="true"
                          :active="loading"
                          height="2"
                          class="ma-0"
                        />
                      </v-flex>
                      <v-flex
                        v-for="fieldName in calculatorVariant.assistanceFields"
                        :key="fieldName"
                        xs12
                      >
                        <SiInputWrapper
                          v-bind="field(fieldName)"
                          apply-layout
                          help-spacing
                        >
                          <component
                            :is="field(fieldName).inputType"
                            v-bind="field(fieldName)"
                            ref="input"
                            v-model="request.data[fieldName]"
                            :save-path="savePath"
                            filled
                          />
                        </SiInputWrapper>
                      </v-flex>
                    </v-form>

                    <v-flex
                      xs12
                      text-right
                    >
                      <v-btn
                        color="primary"
                        large
                        @click="progresToPayment"
                      >
                        Your details & payment <v-icon right>
                          arrow_forward
                        </v-icon>
                      </v-btn>
                    </v-flex>

                    <v-flex
                      xs12
                      class="mt-6"
                    >
                      <SiAlert
                        type="warning"
                        outlined
                        description="If you require more than one valuation for the same interest, select additional valuations from Add-ons. If you require multiple valuations for different interests please submit one request per interest."
                      />
                    </v-flex>
                  </v-flex>
                </v-scroll-y-transition>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-window-item>
      <v-window-item key="2">
        <v-container
          grid-list-lg
          pt-0
          mb-4
          fluid
        >
          <v-layout
            wrap
            justify-center
          >
            <v-flex v-bind="_pageLayout">
              <v-flex
                mt-4
                mb-3
                xs12
              >
                <span class="headline font-weight-light">Payment</span>
                <v-divider />
              </v-flex>
              <v-flex xs12>
                <SiCheckout
                  :skus="skus"
                  :register-paths="[calculationPath, requestPath]"
                  :register-paths-db="[]"
                  :charge-description="chargeDescription"
                  :transaction-id="calculationId"
                  :metadata="metadata"
                  phone
                  allow-invoicing
                  allow-client-reference
                  @finalised="submitRequest"
                />
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { forEach } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import uniqid from 'uniqid'
import helpers from '@/mixins/helpers'
import validation from '@/mixins/validations'
import durations from '@/mixins/durations'
import binder from '@/mixins/binder'
import clientPath from '@/plugins/client-path'

export default {
  mixins: [ helpers, validation, durations, binder ],
  data () {
    return {
      loading: false,
      step: 0,
      formValid: false,
      calculationId: uniqid(),
      request: {
        calculation: {},
        assistanceType: '',
        addons: [],
        data: {}
      },
      // assistanceTypes: [],
      assistanceTypesObj: {},
      calculators: {},
      calculatorFields: {}
    }
  },
  computed: {
    ...mapGetters(['_user', '_pageLayout', '_loader']),
    stepperStep: {
      get: function () {
        return this.step + 1
      },
      set: function (v) {
        this.step = v - 1
      }
    },
    calculatorItems () {
      var a = []
      forEach(this.calculators, (c, cid) => {
        forEach(c.variants, (v, vid) => {
          if (v.canHaveAssistance) {
            a.push({ text: `${v.name} | ${this._$((v.product || {}).price)}`, value: { calculator: cid, variant: vid } })
          }
        })
      })
      return a
    },
    skus () {
      let calculation = this.request.calculation || {}
      let calculationSku = `${calculation.calculator}_${calculation.variant}`
      return [this.request.assistanceType, calculationSku, ...(this.request.addons || [])]
    },
    addons () {
      return this._sortObject(this.calculatorVariant.addons).map(i => ({ text: `${i.name} ( + ${this._$(i.price)})`, subtext: i.subtext, value: i.id })) || []
    },
    selectedAddons () {
      return (this.request.addons || []).map(id => ({ id: id, name: (this.calculatorVariant.addons[id] || {}).name }))
    },
    savePath () {
      return `assistance/requests/${this._user.uid}/${this.calculationId}`
    },
    requestPath () {
      // return `assistance/requests/${this._user.uid}/${this.calculationId}`
      return `assistance/requests/${this.calculationId}`
    },
    calculatorId () {
      return (this.request.calculation || {}).calculator
    },
    calculator () {
      return this.calculators[this.calculatorId] || {}
    },
    calculatorVariantId () {
      return (this.request.calculation || {}).variant
    },
    calculatorVariant () {
      return (this.calculator.variants || {})[this.calculatorVariantId] || {}
    },
    calculationPath () {
      return `calculations/${this.calculatorId}/${this.calculationId}`
    },
    assistFields () {
      let fields = this._sortObject(this.calculatorVariant.assistanceFields) // (this.calculatorVariant.assistanceFields || []).map(x => { return this.calculatorFields[x] || {}})
      return this._sortObject(fields)
    },
    duration () {
      return this.assistanceTypesObj[this.request.assistanceType].duration
    },
    due () {
      return this._dueDate(this.assistanceTypesObj[this.request.assistanceType].duration, new Date().toISOString())
    },
    assistancePath () {
      // return `${this._user.uid}/${this.calculationId}`
      return `${this.calculationId}`
    },
    assistanceId () {
      // return `${this._user.uid}_${this.calculationId}`
      return `${this.calculationId}`
    },
    assistanceTypes () {
      let types = this.assistanceTypesObj
      let calculatorTypes = this.calculatorVariant.assistanceTypes || []
      // return (this.calculatorVariant.assistanceTypes || [])
      //   .map(id => ({ text: `${types[id].name || types[id].id} - ${this._durationText(types[id].duration)} ( + ${this._$(types[id].price)})`, value: types[id].id }))
      return (calculatorTypes)
        .filter(id => !!types[id])
        .map(id => ({ text: `${types[id].name || types[id].id} - ${this._durationText(types[id].duration)} ( + ${this._$(types[id].price)})`, value: types[id].id }))
      
    },
    chargeDescription () {
      let calcId = (this.request.calculation || {}).calculator
      return `Assisted calculation - ${(this.calculators[calcId] || {}).name || ''}`
    },
    metadata () {
      let { assistanceId } = this
      return { type: 'Assistance', assistanceId }
    }
  },
  watch: {
    calculatorId (v) {
      this.$bindRtdb('calculatorFields', `calculators/${v}/structure/fields`, { loader: true })
      // this.$unbind(rtdb.ref(`calculators/${ov}/structure/fields`))
      // this.$bindxxx(rtdb.ref(`calculators/${v}/structure/fields`), 'calculatorFields', true)
    },
    assistanceTypes (types) {
      if (!this.request.assistanceType) this.request.assistanceType = (types[0] || {}).value
    }
  },
  beforeMount () {
    if (this.$route.query.calculator) {
      this.request.calculation = { calculator: this.$route.query.calculator, variant: this.$route.query.variant }
    }

    this.$bindRtdb('assistanceTypesObj', `assistance/_types`)
    this.$bindRtdb('calculators', `calculators/_details`, { loader: 'loading' })

    // this.$bindxxx(rtdb.ref(`assistance/_types`), 'assistanceTypesObj')
    // this.$bindxxx(rtdb.ref(`calculators/_details`), 'calculators', 'loading')
  },

  mounted () {
    clientPath.track(`open_assistance`, { calculatorId: this.calculatorId || null, variantId: this.calculatorVariantId || null })
  },
  methods: {
    field (fieldName) {
      return this.calculatorFields[fieldName] || {}
    },
    progresToPayment () {
      if (this.$refs.form.validate()) {
        this.$vuetify.goTo(0, { duration: 0 })
        this.step = 1
      }
    },
    async submitRequest (client) {
      var updates = {}
      var time = new Date()
      var timestamp = time.toISOString()
      var assistanceType = this.request.assistanceType
      var assistance = this.assistanceTypesObj[assistanceType] || {}
      this.request.id = this.calculationId
      this.request.client = client
      this.request.timestamp = timestamp
      this.request.addonsDisplay = this.selectedAddons

      var publicInfo = {
        title: this.calculatorVariant.name,
        calculationText: this.calculatorVariant.name,
        // assistanceType: assistance.name,
        addons: this.selectedAddons,
        assistanceText: `${assistance.name} (${this._durationText(assistance.duration)})`,
        assistanceDuration: assistance.duration,
        assistanceDue: this._dueDate(assistance.duration, timestamp),
        timestamp,
        status: 'open',
        interactions: {
          submitted: { title: 'Submitted', timestamp, description: 'Assistance request submitted online', icon: 'star' }
        }
      }

      forEach(this.request.data, (data, id) => {
        let dataObj = {
          id: id,
          value: this._removeUndefined(data),
          label: this.field(id).label,
          format: this.field(id).format
        }
        this.request.data[id] = dataObj
      })

      // NOTE: DON"T CHANGE THIS TO A SINGLE UPDATE
      // Must write each path individually as writing as one can overwrite data written by backend such as stripe charges
      updates[`${this.requestPath}/status`] = 'open'
      updates[`${this.requestPath}/request`] = this.request
      updates[`${this.requestPath}/public`] = publicInfo
      updates[`${this.requestPath}/ownerUid`] = this._user.uid


      updates[`${this.calculationPath}/_assisted`] = this.assistancePath
      updates[`${this.calculationPath}/client`] = this._removeUndefined(client)

      await rtdb.ref().update(updates)

      this.$router.push(`/assistance/view/${this.assistancePath}`)

      clientPath.track(`purchase_assistance`, { type: 'purchase_assistance', id: this.assistanceId, calculatorId: this.calculatorId || null, variantId: this.calculatorVariantId || null, assistanceType: this.request.assistanceType })
    }
  }
}
</script>

<style lang="css">

</style>
